import { useAuthStore } from '@/stores/auth';

export function mustBeAdmin() {
  if (!useAuthStore().isAdmin) {
    return false;
  }

  return undefined;
}

export function redirectAdmin(destination) {
  return () => {
    if (useAuthStore().isAdmin) {
      return destination;
    }

    return undefined;
  };
}

export function mustBeSuperAdmin() {
  if (!useAuthStore().isAdmin) {
    return false;
  }

  if (!useAuthStore().isSuperAdmin) {
    return false;
  }

  return undefined;
}

export function mustConfirmEmail() {
  if (!useAuthStore().hasConfirmedEmail) {
    return { name: 'register-confirmation' };
  }

  return undefined;
}
